import Vue from 'vue';
const BotAPI = {
    // Send OAuth code to Botanic for verification
    verifyCode(code, type, url, site) {
        const data = { code, type, url };
        const headers = { 'Site-Name': site };
        return Vue.http.post('chatbots/add_integration/', data, { headers })
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    // Send base64 image, channel and message to share to Slack
    shareToSlack(image, channel, message) {
        return Vue.http.post('chatbots/share/slack/', {
            image,
            channel,
            message,
        })
            .then((response) => Promise.resolve(), (error) => Promise.reject(error));
    },
    // Fetch a list of available Slack channels
    getSlackChannels() {
        return Vue.http.get('chatbots/slack_channels/')
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    // Remove a chat bot integration
    removeIntegration(type) {
        return Vue.http.post('chatbots/remove_integration/', { type })
            .then((response) => Promise.resolve(), (error) => Promise.reject(error));
    },
    addWebhook(type, webhook, channel, team, site) {
        const headers = { 'Site-Name': site };
        const data = { type, webhook, channel, team };
        return Vue.http.post('chatbots/webhook/', data, { headers })
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    listWebhooks(type, site) {
        let headers = {};
        if (site) {
            headers = { 'Site-Name': site };
        }
        return Vue.http.get(`chatbots/webhook/?type=${type}`, { headers })
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    removeWebhook(id, site) {
        const headers = { 'Site-Name': site };
        return Vue.http.delete(`chatbots/webhook/${id}/`, { headers })
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    shareToTeams(imageData, webhookId, msg) {
        return Vue.http.post(`chatbots/webhook/${webhookId}/`, {
            text: `${msg}<br /> ![](${imageData})`,
        }).then((response) => Promise.resolve(), (error) => Promise.reject(error));
    }
};
export default BotAPI;
